/**
 * This Helper will register an event for specified selectlists ("Select No to All?") that
 * contain the values "YES" and "NO". If the selectlist is set to "YES"
 * then all "radio" fields in the SAME fieldset will be set to "NO".
 */

// Setup the namespace for this logic
var selectNoToAllHelper = selectNoToAllHelper || {};


selectNoToAllHelper.initialize = function() {
	ap.consoleInfo("selectNoToAllHelper initialize!");
	
	// Register onChange event handlers for Select No To All fields
	selectNoToAllHelper.sntahRegisterFieldChangeEvent("GeneralQuestionSelectNoToAll");
	selectNoToAllHelper.sntahRegisterFieldChangeEvent("GeneralLiabilityQuestionSelectNoToAll");
	selectNoToAllHelper.sntahRegisterFieldChangeEvent("AutoQuestGenQuestionsSelectNoToAll");
};


selectNoToAllHelper.sntahRegisterFieldChangeEvent = function(fieldId) {  
	var field = page.getField(fieldId);
	if (field != null && field.isHot && !field.autoInvokeAJAX) {
	    var elements = field.getElements();
	    for (var ix in elements) {
	        var element = elements[ix];
	        if (element) {
	            ap.registerEvent(element, 'change', selectNoToAllHelper.sntahOnChangedField);
	        }
	    }
	}
};


// Function will set ALL radio buttons in the same fieldset as the selectlist to NO
selectNoToAllHelper.sntahOnChangedField = function(event) {
    var fieldId = this.id;
    if (fieldId==null || fieldId=="") {
        fieldId = event.srcElement.id;
    }
	
    var field = page.getField(fieldId);
    
    //If the field is not null and the field was set to YES (meaning select NO for all radio buttons).
    if ( field !== null && "YES" == field.getValue() ) {
    	//Get the fieldset ID of the selectlist.
    	var parentFieldsetId = field.parentFieldset.id;
    	
    	//Get the fieldset of the selectlist
    	var fieldset = page.getFieldset(parentFieldsetId);
    	
    	//Get all fields in the fieldset
    	var allFieldsInFieldSet = fieldset.getFields();
    	
    	//Cache the first radio button (to use for making the IPDTR call).
    	var firstRadioField = undefined;
    	
    	//Loop through fieldset fields and if radio button then set to NO
    	for(var fieldIndex = 0; fieldIndex < allFieldsInFieldSet.length; fieldIndex++) {
    		var aField = allFieldsInFieldSet[fieldIndex];
    		if (aField.fieldElementType == "radio") {
    			// Cache the first hotfield radio button (to use for making the IPDTR call).
    			if (firstRadioField === undefined && aField.isHot && field.autoInvokeAJAX) {
    				firstRadioField = aField;
    			}
    			aField.setValue("NO");
    		}
    	}
    	
    	if (firstRadioField !== undefined) {
    		firstRadioField.makeIntraPageDTRRequest();
    	}
    }
};
